import { useLocation } from 'react-router-dom'
import { roles } from '../data/roles.ts'
import { skills } from '../data/skills.ts'
import {
  getJsonLdBreadcrumbList,
  getJsonLdCollectionPage,
  getJsonLdDataset,
  getJsonLdFAQPage,
  getJsonLdMethodologyPage,
  getJsonLdOrganization,
  getJsonLdRolePage,
  getJsonLdSkillPage,
  getJsonLdSoftwareApplication,
  getSeoMeta,
  pageMap,
  type SeoMeta
} from '../utils/seo.ts'
import JsonLd from './JsonLd.tsx'

export default function SchemaManager() {
  const location = useLocation()
  const path = location.pathname.replace(/\/$/, '') || '/'
  const meta = getSeoMeta(path)
  const schemas: Record<string, unknown>[] = []

  if (path === '/') {
    schemas.push(getJsonLdOrganization())
  } else if (path === '/hub') {
    const items = Object.entries(pageMap)
      .filter(([p, _]) => p !== '/')
      .map(([p, m]) => {
        const item = m as SeoMeta
        return { path: p, title: item.title, description: item.description }
      })
    schemas.push(getJsonLdDataset())
    schemas.push(getJsonLdCollectionPage(items))
  } else if (path === '/methodology') {
    schemas.push(getJsonLdMethodologyPage())
  } else if (pageMap[path]) {
    schemas.push(getJsonLdSoftwareApplication(path, meta.title, meta.description))
    if (pageMap[path].faq) {
      schemas.push(getJsonLdFAQPage(pageMap[path].faq!, path))
    }
  } else if (path.startsWith('/role/')) {
    const roleId = path.replace('/role/', '')
    const role = roles.find(r => r.id === roleId)
    if (role) {
      schemas.push(getJsonLdRolePage(role))
      schemas.push(getJsonLdBreadcrumbList([
        { name: 'Home', path: '/' },
        { name: 'All Calculators', path: '/hub' },
        { name: role.title, path: `/role/${role.id}` }
      ]))
    }
  } else if (path.startsWith('/skill/')) {
    const skillId = path.replace('/skill/', '')
    const skill = skills.find(s => s.id === skillId)
    if (skill) {
      schemas.push(getJsonLdSkillPage(skill))
      schemas.push(getJsonLdBreadcrumbList([
        { name: 'Home', path: '/' },
        { name: 'All Calculators', path: '/hub' },
        { name: skill.name, path: `/skill/${skill.id}` }
      ]))
    }
  }

  return <JsonLd id="global-schema" data={schemas} />
}
